const signInFormConstantsEN = {
  signInTitle: 'Sign in',
  emailLabel: 'Email Address',
  passwordLabel: 'Password',
  siginInButtonText: 'Sign In',
  signinForgotPassword: 'Forgot Password?',
  checkboxLabel: 'Remember me',
  siginInInvalidPassword: 'Please enter a valid password',
  siginInInvalidEmail: 'Please enter a valid email address',
  siginInEmptyPassword: 'Please enter your password',
  siginInEmptyEmail: 'Please enter your email',
  noAccount: "Don't have an account?",
  noAccountLinkText: 'Contact Admin',
  reCaptchaValidationError: 'ReCaptcha validation is failed, try again',
  reCaptchaEmptyValidation: 'ReCaptcha is required',
};

export default signInFormConstantsEN;
